<template>
    <div class="w-full">
        <div class="w-full mx-auto">
            <div class="w-full mt-10">
                <h1
                    class="text-center font-bold tracking-wider text-2xl md:text-3xl font-viga text-secondary mb-5"
                >
                    Jadwal Dokter Admin
                </h1>
            </div>
            <div class="w-full mt-5 mb-10 flex">
                <DateInput
                    v-model="tglPeriksaData"
                    class="w-full grow mr-5"
                    id="tgl_periksa"
                    label="PILIH TANGGAL PERIKSA"
                    :custError="
                        $page.props.errors.getJadwalDokterAdmin
                            ? $page.props.errors.getJadwalDokterAdmin.tglPeriksa
                            : ''
                    "
                />
                <button
                    @click.prevent="getJadwalKhusus"
                    class="bg-green-600 hover:bg-green-700 text-white font-bold rounded-3xl flex items-center px-5 py-5 justify-center text-center ml-auto self-end w-36 h-10 text-xs"
                >
                    LIHAT JADWAL
                </button>
            </div>
            <div
                v-if="
                    jadwalDokterData && !$page.props.errors.getJadwalDokterAdmin
                "
                class="w-full my-3"
            >
                <div class="font-poppins mt-2 mb-2 text-right">
                    <p class="font-sm">
                        data diperbaharui pada :
                        <span class="text-red-500">{{ timerCount }} (30 Menit)</span>
                    </p>
                </div>
                <p class="font-poppins font-bold text-center text-xl">
                    Tanggal Periksa: {{ jadwalDokterData.hari }}
                </p>
                <div class="bg-white rounded-md shadow overflow-x-auto scrollbar-thin scrollbar-thumb-amber-600 scrollbar-track-amber-300">
                    <table class="w-full whitespace-nowrap">
                        <thead>
                            <tr class="text-left font-bold bg-amber-100">
                                <th class="py-2 px-3 text-center text-sm">No</th>
                                <th class="py-2 px-3 text-center text-sm">Poliklinik</th>
                                <th class="py-2 px-3 text-center text-sm">Dokter</th>
                                <th class="py-2 px-3 text-center text-sm">Hari</th>
                                <th class="py-2 px-3 text-center text-sm">Jam Praktik</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                v-for="jadwalDokter in jadwalDokterData.data"
                                :key="
                                    jadwalDokter.fs_kd_layanan +
                                    '-' +
                                    jadwalDokter.fs_kd_dokter +
                                    '-' +
                                    jadwalDokter.fs_kd_hari
                                "
                                class="hover:bg-gray-100"
                            >
                                <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                    {{ jadwalDokter.numberRow }}
                                </td>
                                <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                    {{ jadwalDokter.layanan.FS_NM_LAYANAN }}
                                </td>
                                <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                    {{ jadwalDokter.dokter.FS_NM_PEG }}
                                </td>
                                <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                    {{ jadwalDokter.hari.fs_nm_hari }}
                                </td>
                                <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                    {{
                                        jadwalDokter.fs_jam_mulai +
                                        " - " +
                                        jadwalDokter.fs_jam_selesai
                                    }}
                                </td>
                            </tr>
                            <tr v-if="jadwalDokterData.data.length === 0">
                                <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer" colspan="4">
                                    Belum ada data jadwal dokter.
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Link } from "@inertiajs/inertia-vue3";
import LayoutAdmin from "../../../Shared/LayoutAdmin.vue";
import RandomShape from "../../../Shared/RandomShape.vue";
import DateInput from "../../../Shared/DateInput.vue";
export default {
    components: {
        Link,
        RandomShape,
        DateInput,
    },
    data() {
        return {
            tglPeriksaData: this.tglPeriksa,
            jadwalDokterData: this.getInitialState(),
            timerCount: 1800,
        };
    },
    watch: {
        timerCount: {
            handler(value) {
                if (value > 0) {
                    setTimeout(() => {
                        this.timerCount--;
                    }, 1000);
                } else {
                    this.getJadwalKhusus();
                }
            },
            immediate: true,
        },
    },
    props: {
        tglPeriksa: String,
        jadwalDokter: Object,
    },
    methods: {
        getInitialState() {
            var jadwalDokterTemp = [];
            var poliNow = "";
            var numberRow = 1;
            this.jadwalDokter.data.forEach(function (jadwalDokter) {
                if (jadwalDokter.layanan.FS_NM_LAYANAN == poliNow) {
                    poliNow = jadwalDokter.layanan.FS_NM_LAYANAN;
                    jadwalDokter.layanan.FS_NM_LAYANAN = "";
                } else {
                    poliNow = jadwalDokter.layanan.FS_NM_LAYANAN;
                    jadwalDokter.numberRow = numberRow;
                    numberRow += 1;
                }
                jadwalDokterTemp.push(jadwalDokter);
            });
            return {
                hari: this.jadwalDokter.hari,
                data: jadwalDokterTemp,
            };
        },
        getJadwalKhusus() {
            this.$inertia.get(
                "/admin/jadwal_dokter_admin/ajax",
                {
                    tglPeriksa: this.tglPeriksaData,
                },
                {
                    preserveScroll: true,
                    preserveState: true,
                    onSuccess: (page) => {
                        this.timerCount = 1800;
                        var jadwalDokterTemp = [];
                        var poliNow = "";
                        var numberRow = 1;
                        page.props.additional.jadwalDokterAdmin.data.forEach(
                            function (jadwalDokter) {
                                if (
                                    jadwalDokter.layanan.FS_NM_LAYANAN ==
                                    poliNow
                                ) {
                                    poliNow =
                                        jadwalDokter.layanan.FS_NM_LAYANAN;
                                    jadwalDokter.layanan.FS_NM_LAYANAN = "";
                                } else {
                                    poliNow =
                                        jadwalDokter.layanan.FS_NM_LAYANAN;
                                    jadwalDokter.numberRow = numberRow;
                                    numberRow += 1;
                                }
                                jadwalDokterTemp.push(jadwalDokter);
                            }
                        );
                        this.jadwalDokterData = {
                            hari: page.props.additional.jadwalDokterAdmin.hari,
                            data: jadwalDokterTemp,
                        };
                    },
                    errorBag: "getJadwalDokterAdmin",
                }
            );
        },
    },
    layout: LayoutAdmin,
};
</script>
